import type { DiagramSpec } from "../types"

export const aiStackDiagram: DiagramSpec = {
  id: "ai-stack",
  name: "AI Model Stack",
  description: "Models, providers, and what they power across the system",
  layers: [
    { id: "tasks", name: "Tasks", color: "#a78bfa" },
    { id: "models", name: "Models", color: "#38bdf8" },
    { id: "providers", name: "Providers", color: "#fb923c" },
  ],
  nodes: [
    {
      id: "t-code",
      label: "Code Generation",
      layer: "tasks",
      rank: 0,
      description: "Brain skills, aix-turborepo, all TypeScript",
      html: '<div style="font-size:20px;text-align:center">🧑‍💻</div>',
    },
    {
      id: "t-chat",
      label: "Chat / Reasoning",
      layer: "tasks",
      rank: 0,
      description: "Telegram conversations, decisions, analysis",
      html: '<div style="font-size:20px;text-align:center">💬</div>',
    },
    {
      id: "t-search",
      label: "Web Search",
      layer: "tasks",
      rank: 0,
      description: "Research, news feeds, product lookup",
      html: '<div style="font-size:20px;text-align:center">🔍</div>',
    },
    {
      id: "t-video",
      label: "Video Gen",
      layer: "tasks",
      rank: 0,
      description: "VidMax pipelines, talking heads, animations",
      html: '<div style="font-size:20px;text-align:center">🎬</div>',
    },
    {
      id: "t-voice",
      label: "Voice / TTS",
      layer: "tasks",
      rank: 0,
      description: "Voiceovers, voice calls via Vapi",
      html: '<div style="font-size:20px;text-align:center">🎙️</div>',
    },
    {
      id: "t-summarize",
      label: "Summarization",
      layer: "tasks",
      rank: 0,
      description: "LCM compaction, transcript digests",
      html: '<div style="font-size:20px;text-align:center">📝</div>',
    },

    {
      id: "m-opus",
      label: "Claude Opus 4",
      layer: "models",
      rank: 1,
      fields: { Cost: "$$$$", Speed: "Slow", Use: "Complex reasoning" },
    },
    {
      id: "m-sonnet",
      label: "Claude Sonnet 4",
      layer: "models",
      rank: 1,
      fields: { Cost: "$$", Speed: "Fast", Use: "Default coding + chat" },
    },
    {
      id: "m-haiku",
      label: "Claude Haiku 3.5",
      layer: "models",
      rank: 1,
      fields: { Cost: "$", Speed: "Fastest", Use: "Summarization, triage" },
    },
    {
      id: "m-sonar",
      label: "Sonar Pro",
      layer: "models",
      rank: 1,
      fields: { Cost: "$$", Speed: "Medium", Use: "Web search with citations" },
    },
    {
      id: "m-runway",
      label: "Runway Gen-3",
      layer: "models",
      rank: 1,
      fields: { Cost: "$$$", Speed: "Slow", Use: "Video generation" },
    },
    {
      id: "m-11labs",
      label: "ElevenLabs v2",
      layer: "models",
      rank: 1,
      fields: { Cost: "$$", Speed: "Fast", Use: "Voice synthesis" },
    },
    {
      id: "m-heygen",
      label: "HeyGen",
      layer: "models",
      rank: 1,
      fields: { Cost: "$$$", Speed: "Slow", Use: "AI avatars" },
    },

    {
      id: "p-anthropic",
      label: "Anthropic",
      layer: "providers",
      rank: 2,
      description: "Claude models via direct API",
      fields: { Auth: "API Key", Billing: "Per-token" },
    },
    {
      id: "p-openrouter",
      label: "OpenRouter",
      layer: "providers",
      rank: 2,
      description: "Multi-model proxy for Sonar, Haiku",
      fields: { Auth: "API Key", Billing: "Per-token" },
    },
    {
      id: "p-runway",
      label: "Runway",
      layer: "providers",
      rank: 2,
      description: "Video generation API",
      fields: { Auth: "API Key", Billing: "Per-second" },
    },
    {
      id: "p-elevenlabs",
      label: "ElevenLabs",
      layer: "providers",
      rank: 2,
      description: "Voice synthesis API",
      fields: { Auth: "API Key", Billing: "Per-character" },
    },
  ],
  edges: [
    { id: "e-code-sonnet", source: "t-code", target: "m-sonnet" },
    { id: "e-code-opus", source: "t-code", target: "m-opus" },
    { id: "e-chat-sonnet", source: "t-chat", target: "m-sonnet" },
    { id: "e-chat-opus", source: "t-chat", target: "m-opus" },
    { id: "e-search-sonar", source: "t-search", target: "m-sonar" },
    { id: "e-video-runway", source: "t-video", target: "m-runway" },
    { id: "e-video-heygen", source: "t-video", target: "m-heygen" },
    { id: "e-voice-11labs", source: "t-voice", target: "m-11labs" },
    { id: "e-summarize-haiku", source: "t-summarize", target: "m-haiku" },

    { id: "e-opus-anthropic", source: "m-opus", target: "p-anthropic" },
    { id: "e-sonnet-anthropic", source: "m-sonnet", target: "p-anthropic" },
    { id: "e-haiku-openrouter", source: "m-haiku", target: "p-openrouter" },
    { id: "e-sonar-openrouter", source: "m-sonar", target: "p-openrouter" },
    { id: "e-runway-runway", source: "m-runway", target: "p-runway" },
    { id: "e-11labs-elevenlabs", source: "m-11labs", target: "p-elevenlabs" },
    { id: "e-heygen-elevenlabs", source: "m-heygen", target: "p-elevenlabs", style: "dashed" },
  ],
  views: [
    { id: "full", name: "Full Stack", layout: "TB" },
    { id: "tasks-models", name: "Tasks → Models", layers: ["tasks", "models"], layout: "TB" },
    { id: "models-providers", name: "Models → Providers", layers: ["models", "providers"], layout: "LR" },
  ],
  defaultView: "full",
}
